import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="bg-[#F8F8F8] py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden bg-white rounded-2xl">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 right-0 w-72 h-72 bg-[#ADD8E6]/20 rounded-full translate-x-1/3 -translate-y-1/3" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#003366]/5 rounded-full -translate-x-1/3 translate-y-1/3" />
          </div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-10 p-10 lg:p-16">
            {/* Image */}
            <div className="w-full lg:w-2/5 flex-shrink-0 rounded-xl overflow-hidden">
              <div className="h-64 lg:h-80 w-full">
                <img
                  src="https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774351696/team-together_lm6gqf.jpg"
                  alt="Join Us"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 text-center lg:text-left">
              <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest">
                Get Involved
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mt-2 mb-4">
                Join Us in Making a Difference
              </h2>
              <p className="text-gray-500 text-base leading-relaxed mb-8">
                Whether you are an individual, a church, a business, or an organization — there is a place for you in our mission. Your support transforms communities across Uganda and builds a future of hope.
              </p>
              <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
                <Link
                  to="/donate"
                  className="px-7 py-3 bg-[#003366] text-white font-semibold text-sm rounded-lg hover:bg-[#002244] transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Donate Now
                </Link>
                <Link
                  to="/contact"
                  className="px-7 py-3 bg-[#ADD8E6] text-[#003366] font-semibold text-sm rounded-lg hover:bg-[#003366] hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Partner With Us
                </Link>
                <Link
                  to="/contact"
                  className="px-7 py-3 border-2 border-[#003366] text-[#003366] font-semibold text-sm rounded-lg hover:bg-[#003366] hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Volunteer
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Image strip */}
        <div className="mt-10 grid grid-cols-3 sm:grid-cols-5 gap-3">
          {[
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601124/WhatsApp_Image_2026-07-07_at_18.47.46_aw6c3j.jpg', alt: '' },
             { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601124/WhatsApp_Image_2026-07-08_at_14.03.42_nku8a8.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601124/WhatsApp_Image_2026-07-09_at_11.58.47_ggesrb.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601126/WhatsApp_Image_2026-07-09_at_11.58.49_2_bshxsb.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601126/WhatsApp_Image_2026-07-09_at_11.58.49_nb8d5u.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601125/WhatsApp_Image_2026-07-09_at_11.58.49_1_flwht1.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601125/WhatsApp_Image_2026-07-09_at_11.58.48_sqa1iv.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601125/WhatsApp_Image_2026-07-09_at_11.58.48_1_nhmku1.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601125/WhatsApp_Image_2026-07-09_at_11.58.48_3_mzmnuk.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1783601124/WhatsApp_Image_2026-07-08_at_14.03.42_1_xuvqqn.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/v1782151234/tailor_ifujit.jpg', alt: '' },
             { src: 'https://res.cloudinary.com/deftrem1m/image/upload/q_auto/f_auto/v1780592399/9_xogapi.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/deftrem1m/image/upload/q_auto/f_auto/v1780592399/9_xogapi.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/q_auto/f_auto/v1780337741/WhatsApp_Image_2026-06-01_at_19.53.39_ob5aev.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/q_auto/f_auto/v1780337640/WhatsApp_Image_2026-06-01_at_17.15.27_nukyff.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/darliwxtt/image/upload/q_auto/f_auto/v1780337740/ch2_scwyjg.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1776317371/6_kch7r6.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1776317372/9_l9wfan.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1776317372/12_e2pwkb.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774815228/computer2_oty2kv.jpg', alt: 'Education' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775055118/msc_ozcrr5.jpg', alt: 'Tailoring' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775055117/guitr2_iufxo7.jpg', alt: 'Farming' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775093596/ChatGPT_Image_Apr_2_2026_04_32_07_AM_tspoeh.png', alt: 'Health' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775093596/ChatGPT_Image_Apr_2_2026_04_26_39_AM_oh20p1.png', alt: 'Elderly Care' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775055120/guitr_jjs3ar.jpg', alt: 'Farming' },
            { src: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774804828/c-training_f09mm9.jpg', alt: 'Farming' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775055141/WhatsApp_Image_2026-04-01_at_14.38.15_znf0wc.jpg', alt: 'Farming' },
            { src: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774804858/tailoring_gnrlsx.jpg', alt: 'Farming' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775057673/health---_oku5kk.jpg', alt: 'Farming' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775203659/WhatsApp_Image_2026-04-03_at_09.25.00_bfdbai.jpg', alt: '' },
            { src: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775203659/WhatsApp_Image_2026-04-03_at_09.24.57_1_uhhwcy.jpg', alt: '' },
          ].map((img) => (
            <div key={img.alt} className="rounded-lg overflow-hidden h-24 sm:h-28">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover object-top" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
